import styled from "styled-components";

export const CartParent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    background: #eeeeee;
`;


export const Wrapper = styled.div`
display: flex;
flex: 1;
border: 1px solid #eeeeee;
display: flex;
flex-direction: column;
background: #eeeeee;
height:100%;
       
`;




export const CartInformationParent = styled.section`
  width: 50%;
  height: 70vh;
  display: flex;
  border-radius: 12px;
  background:#ffffff;
  margin-top: 5rem;
  margin-left:1rem;
  border: 1px solid #fefefe;
`;

export const CartInfoWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 1rem;
`;

export const Heading = styled.h3`
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 3rem;
  color: #1e1e1e;
  margin-left:1rem;

`;



export const NavBarContainer = styled.div`
    width: 100%;
    height: 10%;
    background: #fff;
    display: flex;
    
`;